import { useState } from 'react';

/** Gear as tags: tap the common ones, type anything else. */
export default function GearPicker({ value = [], onChange, suggestions = [], label = 'Materiel apporte' }) {
  const [draft, setDraft] = useState('');

  const toggle = (tag) =>
    onChange(value.includes(tag) ? value.filter((g) => g !== tag) : [...value, tag]);

  const addDraft = () => {
    const tag = draft.trim();
    if (!tag || value.includes(tag)) {
      setDraft('');
      return;
    }
    onChange([...value, tag]);
    setDraft('');
  };

  const custom = value.filter((g) => !suggestions.includes(g));

  return (
    <div className="field">
      <span className="field-label">{label}</span>
      <div className="row wrap gap-6">
        {suggestions.map((tag) => (
          <button
            key={tag}
            type="button"
            className="chip chip-btn"
            aria-pressed={value.includes(tag)}
            onClick={() => toggle(tag)}
          >
            {tag}
          </button>
        ))}
      </div>
      {custom.length > 0 && (
        <div className="row wrap gap-6" style={{ marginTop: 2 }}>
          {custom.map((tag) => (
            <span key={tag} className="chip chip-accent">
              {tag}
              <button
                type="button"
                className="btn btn-ghost"
                style={{ padding: 0, width: 14, height: 14, fontSize: 11 }}
                onClick={() => toggle(tag)}
                aria-label={`Retirer ${tag}`}
              >
                ✕
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="row gap-8">
        <input
          className="input"
          value={draft}
          placeholder="Autre materiel..."
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addDraft();
            }
          }}
        />
        <button type="button" className="btn btn-sm" onClick={addDraft} disabled={!draft.trim()}>
          Ajouter
        </button>
      </div>
    </div>
  );
}
